<template>
  <footer>
    <div class="footer-content">
      <div class="footer-logo">Evelina Lodi</div>
      <ul class="footer-links">
        <li><router-link to="/packages">Packages</router-link></li>
        <li><router-link to="/portfolio">Portfolio</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
      </ul>
    </div>
    <p class="footer-copyright">&copy; {{ currentYear }} Evelina Lodi Photography. All Rights Reserved.</p>
  </footer>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "FooterComponent",
  setup() {
    const currentYear = computed(() => new Date().getFullYear());
    return { currentYear };
  },
});
</script>

<style lang="scss" scoped>
footer {
  background: var(--charcoal);
  padding: 3rem 5%;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.6);
}


.footer-logo {
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-weight: 400;
}

.footer-links {
  display: flex;
  gap: 2.5rem;
  list-style: none;

  a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    font-size: 0.7rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    transition: color 0.3s ease;
    font-weight: 400;

    &:hover {
      color: white;
    }
  }
}

.footer-copyright {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }

  .footer-links {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
